import './index.css';
/*import { make } from '../../../utils';*/

import Paragraph from '@editorjs/paragraph';

export default class CustomParagraph extends Paragraph {

  static get sanitize() {
	return {
	  text: {
		br: true,
		//span: {
		//  id: true,
		//  contenteditable: true,
		//  class: true
		//}
	  }
	};
  }
}